module.exports = __webpack_public_path__ + "img/trash2-fill.e63acab6.svg";